export const floatToString = (float: number) => {
  const numberFormat = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    currencyDisplay: 'code',
  });

  return numberFormat.format(float).replace('BRL', '').trim();
};
